
/* ============================================================
   RUNE — every number, price and string lives here
   ============================================================ */
const CFG = {
  led: 142,
  session: 20,
  rating: '4.9',
  ratingCount: 108,
  guaranteeDays: 90,
  warrantyMonths: 24,
  cur: '€',
  products: { cap:{price:179}, guide:{price:29} },
  payment: [
    { id:'card',   name:'Card',       note:'Visa and Mastercard, secured by 3D Secure' },
    { id:'apple',  name:'Apple Pay',  note:'Pay with one touch' },
    { id:'google', name:'Google Pay', note:'Pay with one touch' }
  ],
  cost: [
    ['__SOLO__','Once, then never again','No refills. No subscription. No box turning up every month.'],
    ['90 days','To change your mind','Use it properly. Not convinced? We refund you.'],
    ['24 months','Warranty','On the electronics and the battery.']
  ]
};
CFG.bundles = [
  { id:'solo', name:'RUNE ONE', price:197, sub:'Cap, remote and The Hair Protocol guide included',
    items:[{t:'RUNE ONE cap, 142 diodes',base:true},{t:'Remote control and USB-C cable',base:true},{t:'90-day money-back guarantee',base:true},{t:'“The Hair Protocol” — the 38-page guide, __GV__ included. In your inbox the moment you pay'}] }
];

const REVBA=(window.RUNE&&RUNE.ba)||[];
const GAL=(window.RUNE&&RUNE.gal)||[];

/* Shopify variants -> bundles (prices come from Shopify in the visitor's currency) */
(function(){
  const V=(window.RUNE&&RUNE.variants)||[], P=(window.RUNE&&RUNE.prices)||[], CP=(window.RUNE&&RUNE.compare)||[];
  ['solo'].forEach((id,i)=>{ const b=CFG.bundles.find(x=>x.id===id);
    if(b&&V[i]){ b.vid=V[i]; if(P[i]) b.price=P[i]/100; b.save=(CP[i]&&CP[i]>P[i])?(CP[i]-P[i])/100:0; } });
})();

const C = {
  bens:[
    'Less thinning, more hair',
    'Stronger strands, straight from the root',
    'Better circulation, a calmer scalp'
  ],
  strip:[
    ['rosette','FDA cleared'],
    ['truck','Free shipping in Europe'],
    ['shield','90-day money back'],
    ['check','2-year warranty']
  ],
  steps:[
    ['01','Put it on','Fits like a cap, because it is one. 142 diodes cover crown, temples and hairline. Nothing to aim.'],
    ['02','Press start','Pick your setting on the remote. Set twenty minutes and the cap shuts itself off. Nothing to watch.'],
    ['03','Carry on','Battery powered. Cook, answer email, walk the dog. Twenty minutes later it shuts itself off.']
  ],
  stats:[
    { n:'95%', num:95, suf:'%', h:'of women grew more hair',
      t:'In a double-blind trial of 269 people, 95% of the women using red light gained more than five hairs per square centimetre after 26 weeks. In the sham group it was 32%.',
      c:'Jimenez et al., American Journal of Clinical Dermatology, 2014' },
    { n:'83%', num:83, suf:'%', h:'of men, same result',
      t:'Same trial, same measurement, male arm. Eighty-three percent against 43% on the sham device. The therapy works on both sexes.',
      c:'Jimenez et al., American Journal of Clinical Dermatology, 2014' },
    { n:'98%', num:98, suf:'%', h:'held steady or improved',
      t:'A 12-month follow-up published in 2026. In 98% of participants hair loss stopped or density went up. Fewer than 2% got worse. No device-related adverse events.',
      c:'Shin et al., Dermatologic Therapy, 2026' }
  ],
  mw:[
    ['95%','Women','Thinning in women shows up as a part that keeps widening and a crown that loses density — exactly where the diodes sit. In a 269-person trial, 95% of the women using red light gained hair. In the sham group, 32%.'],
    ['83%','Men','In men the temples and crown go first, and they go quietly. In the same trial, 83% of the men using red light gained hair against 43% on the sham device. The earlier you start, the more follicles are still there to save.']
  ],
  spec:[
    ['Model','RUNE ONE'],
    ['Diodes','142 groups (284 beams)'],
    ['Wavelengths','660 nm (red) and 940 nm (near-infrared)'],
    ['Session','Timer set on the remote, switches off automatically'],
    ['Remote','5 brightness levels, 3 light modes, infrared on/off'],
    ['Frequency','Every other day'],
    ['Power','Built-in 2600 mAh battery, USB-C charging'],
    ['Weight','249 g'],
    ['In the box','Cap, remote control, USB-C cable, instruction manual'],
    ['Certification','FDA cleared · CE marked'],
    ['Warranty','24 months']
  ],
  reviews:[
    { t:"This cap is very easy to use, and it works amazingly. I had the beginnings of a hair recession at the front top of my head. My hair is much thicker and shinier and healthier — it is looking more and more like the great-looking hair I remember. I feel proud of my hair again.", m:'J. H.', d:'3 Nov 2025', ba:1 },
    { t:"Arrived safely and the device works. The LEDs are bright and the battery has lasted several sessions without a recharge. It's early to judge the therapy — that takes time — but I read a study on red light and hair growth, so I'm hopeful. Happy with the purchase and I'd buy again.", m:'L. V.', d:'8 May 2026' },
    { t:"Excellent. Charges over USB and I've used it several times without needing to top it up. Very good product and exactly what it looks like in the photos. Would recommend it to anyone.", m:'K. M.', d:'24 Mar 2026' }
  ],
  faq:[
    ['Will it work for me?','If your hair is thinning, yes — and it makes no difference whether you are a man or a woman. A meta-analysis of seven trials covering 607 people found effectively the same result in both. While hair is thinning, the follicles are alive and there is something to work with. The one exception is scalp that has been completely bare and shiny for years — there is no follicle left there to reach.'],
    ['How soon will I see something?','Most people first notice that less hair is coming out, usually somewhere between week two and week six. Measurable density changes show up from week sixteen in the trials and keep improving after that. Hair grows about a centimetre a month, and nobody can speed that up.'],
    ['Is it safe?','Yes. Low-level red and near-infrared light does not heat the skin or damage it. Across seven trials no adverse events were recorded. If you are being treated for a scalp condition, take medication that increases light sensitivity, or have an implant in your head, check with your doctor first.'],
    ['How often should I use it?','Every other day, twenty minutes. More is not better — consistency is what matters. Set the timer to twenty minutes and the cap switches itself off.'],
    ['Can I combine it with minoxidil or finasteride?','Yes. The methods do not interfere with each other and the combination has been studied. If you are on something prescribed, mention it to the doctor who prescribed it.'],
    ['Can people tell I am wearing it?','From the outside it is a plain dark cap. The light is on the inside and nothing shows.'],
    ['Does it matter if I skip a day?','One day makes no difference. Skipped weeks do. That is exactly why the guide is included with your cap — it turns this into a habit you actually keep.'],
    ['What is in the guide?','A 38-page PDF, emailed the moment your payment goes through. It covers how to use the cap and the mistakes that quietly undo the results; a five-minute daily routine for washing, drying and brushing; what your diet does to your hair — iron, ferritin, protein and vitamin D, and how to tell when something is missing; why hair falls out three months after a stressful period rather than during it; how to photograph your progress so the comparison holds up; and a plain list of what works, what is a waste of money, and when to see a dermatologist instead.'],
    ['Can two people share one cap?','Physically, yes. In practice it gets awkward fast — sessions run every other day each, so one cap means one of you is always waiting. If you both want to use it, the simplest answer is a second cap, so neither of you has to think about whose turn it is.'],
    ['What if it is not for me?','You have 90 days to decide. Write to us and we will refund you. On top of that, EU consumers keep the statutory 14-day right of withdrawal.'],
    ['How can I pay?','Visa or Mastercard, Apple Pay or Google Pay. Payment runs through a secured gateway — your card details never reach us.'],
    ['Where do you ship?','Everywhere in Europe, free of charge, on every order.']
  ],
  reassure:[
    '90 days to change your mind, no explanation needed',
    'Free shipping across Europe',
    '24-month warranty',
    'Real people on email, replies within 24 hours'
  ]
};

const $=(s,r)=>(r||document).querySelector(s);
const $$=(s,r)=>Array.from((r||document).querySelectorAll(s));
const CURISO=(window.RUNE&&RUNE.currency)||'EUR';
const money=n=>{
  const loc=CURISO==='CZK'?'cs-CZ':(CURISO==='EUR'?'en-IE':undefined), d=Math.abs(n%1)>0.004?2:0;
  try{ return new Intl.NumberFormat(loc,{style:'currency',currency:CURISO,minimumFractionDigits:d,maximumFractionDigits:d}).format(n); }
  catch(e){ return CFG.cur+n.toLocaleString('en-US'); }
};
const subOf=b=>String(b.sub||'').replace('__HALF__',money(b.price/2));
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const TICK='<svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 8.5l4 4 7-8.5"/></svg>';
const ICONS={
  shield:'<svg width="26" height="26" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 1.5l7 2.5v6c0 4-3 7.3-7 8.5-4-1.2-7-4.5-7-8.5v-6z"/><path d="M7 10l2 2 4-4"/></svg>',
  truck:'<svg width="26" height="26" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 5h11v9H1zM12 8h4l3 3v3h-7z"/><circle cx="5" cy="16" r="1.6"/><circle cx="15" cy="16" r="1.6"/></svg>',
  chat:'<svg width="26" height="26" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11.5a2.5 2.5 0 01-2.5 2.5H6l-4 4V4.5A2.5 2.5 0 014.5 2h11A2.5 2.5 0 0118 4.5z"/></svg>',
  check:'<svg width="26" height="26" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="8"/><path d="M6.5 10.2l2.4 2.4 4.6-5"/></svg>',
  rosette:'<svg width="27" height="27" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8.6" r="6.4"/><path d="M9.2 8.5l1.9 1.9 3.7-3.7"/><path d="M8.1 14.4L6.6 21.5l5.4-2.6 5.4 2.6-1.5-7.1"/></svg>'
};

function dome(el){
  if(!el||el.dataset.b) return; el.dataset.b='1';
  const rings=[[0,1],[15,7],[27,13],[38,16],[48,18],[57,20]];
  let i=0;
  rings.forEach(([r,n],ri)=>{ for(let k=0;k<n;k++){
    const a=(k/n)*Math.PI*2+ri*0.37, d=document.createElement('i');
    d.className='dot';
    d.style.left=(50+Math.cos(a)*r)+'%';
    d.style.top=(50+Math.sin(a)*r*0.9)+'%';
    d.style.animationDelay=((i*83)%2800)/1000+'s';
    d.style.opacity=(1-ri*0.055).toFixed(2);
    el.appendChild(d); i++;
  }});
}

function ring(el){
  if(!el||el.dataset.r) return; el.dataset.r='1';
  const R=18, CIRC=2*Math.PI*R, DUR=9000;
  const card=document.createElement('button');
  card.className='ring-card'; card.type='button';
  card.innerHTML='<svg width="46" height="46" viewBox="0 0 46 46" aria-hidden="true">'+
    '<circle cx="23" cy="23" r="'+R+'" fill="none" stroke="#2E2620" stroke-width="4"/>'+
    '<circle class="ring-prog" cx="23" cy="23" r="'+R+'" fill="none" stroke="#FF5B3C" stroke-width="4" stroke-linecap="round" stroke-dasharray="'+CIRC.toFixed(1)+'" stroke-dashoffset="'+CIRC.toFixed(1)+'" transform="rotate(-90 23 23)"/></svg>'+
    '<span><span class="rt" data-t>20:00</span><span class="rs" data-s>Watch a session</span></span>';
  el.appendChild(card);
  const prog=card.querySelector('.ring-prog'), tEl=card.querySelector('[data-t]'), sEl=card.querySelector('[data-s]');
  let raf=null,t0=null;
  function stop(done){
    if(raf) cancelAnimationFrame(raf);
    raf=null; el.classList.remove('run');
    prog.style.strokeDashoffset=CIRC.toFixed(1);
    tEl.textContent='20:00';
    sEl.textContent=done?'Done — it switched itself off':'Watch a session';
  }
  function step(ts){
    if(!t0) t0=ts;
    const p=Math.min((ts-t0)/DUR,1);
    prog.style.strokeDashoffset=(CIRC*(1-p)).toFixed(1);
    const left=Math.ceil(20*60*(1-p));
    tEl.textContent=Math.floor(left/60)+':'+String(left%60).padStart(2,'0');
    sEl.textContent='Session running…';
    if(p<1) raf=requestAnimationFrame(step); else stop(true);
  }
  card.addEventListener('click',()=>{
    if(raf){ stop(false); return; }
    t0=null; el.classList.add('run'); raf=requestAnimationFrame(step);
  });
}

function spectrum(el){
  if(!el||el.dataset.b) return; el.dataset.b='1';
  const pos=nm=>((nm-400)/600*100);
  el.innerHTML='<div class="spec-bar">'+
    '<div class="spec-edge" style="left:'+pos(700)+'%"></div>'+
    '<div class="spec-mark" style="left:'+pos(660)+'%"><span>660 nm</span></div>'+
    '<div class="spec-mark" style="left:'+pos(940)+'%"><span>940 nm</span></div></div>'+
    '<div class="spec-scale">'+[400,500,600,700,800,900,1000].map(t=>'<div class="spec-tick" style="left:'+pos(t)+'%">'+t+'</div>').join('')+
    '<div class="spec-tick lbl" style="left:'+pos(700)+'%;top:21px">edge of visible light</div></div>';
}

function chart(el){
  if(!el||el.dataset.b) return; el.dataset.b='1';
  const MAX=23, rows=[
    ['Women — sham device',2.8,false],
    ['Women — red light',20.2,true],
    ['Men — sham device',1.6,false],
    ['Men — red light',18.4,true]
  ];
  el.innerHTML='<h4>New hairs gained per square centimetre</h4>'+
    '<p class="tiny" style="color:var(--panel-ink-2)">Change in hair count after 26 weeks. 269 participants, randomly assigned, double-blind — neither they nor the doctors knew who had the working device.</p>'+
    rows.map(r=>'<div class="bar-row"><span class="bar-l">'+r[0]+'</span><span class="bar-t"><span class="bar-f'+(r[2]?' hot':'')+'" data-w="'+(r[1]/MAX*100).toFixed(1)+'" style="width:0"></span><span class="bar-v">+'+r[1]+'</span></span></div>').join('')+
    '<p class="cite" style="margin-top:18px">Jimenez et al., American Journal of Clinical Dermatology, 2014 — significant in both arms (p &lt; 0.0001 for women, p = 0.0017 for men).</p>';
}

const R={
  bens:el=>el&&(el.innerHTML=C.bens.map(t=>'<li class="ben"><i>'+TICK+'</i><span>'+esc(t)+'</span></li>').join('')),
  strip:el=>el&&(el.innerHTML=C.strip.map(([ic,a])=>'<div class="badge-c"><i>'+ICONS[ic]+'</i><span>'+esc(a)+'</span></div>').join('')),
  steps:el=>el&&(el.innerHTML=C.steps.map(([n,h,p])=>'<div class="card"><span class="n">'+n+'</span><h3 class="h3">'+esc(h)+'</h3><p class="muted" style="font-size:15.5px">'+esc(p)+'</p></div>').join('')),
  stats:el=>el&&(el.innerHTML=C.stats.map(s=>'<div class="stat"><span class="stat-n" data-n="'+s.num+'" data-suf="'+s.suf+'">'+esc(s.n)+'</span><h4>'+esc(s.h)+'</h4><p>'+esc(s.t)+'</p><span class="cite">'+esc(s.c)+'</span></div>').join('')),
  mw:el=>el&&(el.innerHTML=C.mw.map(([p,h,t])=>'<div class="card"><span class="pct">'+esc(p)+'</span><h3 class="h3">'+esc(h)+'</h3><p class="muted" style="font-size:15.5px">'+esc(t)+'</p></div>').join('')),
  spec:el=>el&&(el.innerHTML=C.spec.map(([k,v])=>'<div><dt>'+esc(k)+'</dt><dd>'+esc(v)+'</dd></div>').join('')),
  revs:el=>el&&(el.innerHTML=C.reviews.map(r=>'<article><div class="stars"><span class="s">★★★★★</span></div><p>'+esc(r.t)+'</p>'+
    (r.ba?'<div class="rev-ba">'+REVBA.map(x=>'<figure><img src="'+x.src+'" alt="'+esc(x.alt)+'" loading="lazy"><figcaption>'+esc(x.l)+'</figcaption></figure>').join('')+'</div>':'')+
    (r.ph?'<div class="rev-ph">'+Array.from({length:r.ph},()=>'<span>PHOTO</span>').join('')+'</div>':'')+
    '<span class="rev-m"><b>'+esc(r.m)+'</b><span>'+esc(r.d)+'</span><span class="vbadge">'+TICK+'Verified buyer</span></span></article>').join('')),
  faq:(el,n)=>el&&(el.innerHTML=(n?C.faq.slice(0,n):C.faq).map(([q,a])=>'<details><summary>'+esc(q)+'</summary><div class="ans">'+esc(a)+'</div></details>').join('')),
  stars:el=>el&&(el.innerHTML='<span class="s">★★★★★</span><b>'+CFG.rating+'</b><a data-goto="reviews">'+CFG.ratingCount+' reviews</a>'),
  reassure:el=>el&&(el.innerHTML=C.reassure.map(t=>'<li>'+TICK+'<span>'+esc(t)+'</span></li>').join('')),
  pays:el=>el&&(el.innerHTML=
    '<span class="pay" title="Visa"><span class="vs">VISA</span></span>'+
    '<span class="pay" title="Mastercard"><svg width="30" height="19" viewBox="0 0 30 19" aria-hidden="true"><circle cx="11.2" cy="9.5" r="8.6" fill="#EB001B"/><circle cx="18.8" cy="9.5" r="8.6" fill="#F79E1B"/><path d="M15 2.9a8.6 8.6 0 000 13.2 8.6 8.6 0 000-13.2z" fill="#FF5F00"/></svg></span>'+
    '<span class="pay" title="Apple Pay"><svg width="13" height="16" viewBox="0 0 17 21" fill="#000" aria-hidden="true"><path d="M14.2 11.1c0-2.4 2-3.6 2.1-3.6-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.1-.8-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.2 1.2 9.5.8 1.1 1.7 2.4 3 2.4 1.2 0 1.6-.8 3.1-.8 1.4 0 1.8.8 3.1.7 1.3 0 2.1-1.1 2.9-2.3.9-1.3 1.3-2.6 1.3-2.7-.1 0-2.5-1-2.5-3.8zM11.8 3.9c.7-.8 1.1-2 1-3.1-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1 3 1.1.1 2.2-.6 2.9-1.4z"/></svg><span class="lbl">Pay</span></span>'+
    '<span class="pay" title="Google Pay"><svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5c-.3 1.5-1.1 2.8-2.4 3.6v3h3.9c2.3-2.1 3.5-5.2 3.5-8.8z"/><path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.5 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1C3.4 21.4 7.4 24 12 24z"/><path fill="#FBBC05" d="M5.4 14.4c-.2-.7-.4-1.5-.4-2.4s.2-1.7.4-2.4V6.5H1.4C.5 8.2 0 10 0 12s.5 3.8 1.4 5.5l4-3.1z"/><path fill="#EA4335" d="M12 4.8c1.8 0 3.3.6 4.6 1.8l3.4-3.4C17.9 1.2 15.2 0 12 0 7.4 0 3.4 2.6 1.4 6.5l4 3.1C6.3 6.8 8.9 4.8 12 4.8z"/></svg><span class="lbl">Pay</span></span>'),
  cost:el=>el&&(el.innerHTML=CFG.cost.map(([n,h,t])=>'<div class="card"><span class="pct">'+esc(String(n).replace('__SOLO__',money(CFG.bundles[0].price)))+'</span><h3 class="h3">'+esc(h)+'</h3><p class="muted" style="font-size:15.5px">'+esc(t)+'</p></div>').join('')),
  snip:el=>{ if(!el) return; const r=C.reviews[0];
    el.innerHTML='<div class="stars"><span class="s">★★★★★</span><b>'+CFG.rating+'</b><span class="muted">from '+CFG.ratingCount+' reviews</span></div><p>“'+esc(r.t.slice(0,118))+'…”</p><button class="sb" data-goto="reviews">Read all reviews ↓</button>'; }
};

function countUp(){
  const els=$$('.stat-n[data-n]').filter(e=>!e.dataset.io);
  if(!els.length||!('IntersectionObserver' in window)) return;
  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(!e.isIntersecting||e.target.dataset.done) return;
    e.target.dataset.done='1';
    const el=e.target, end=+el.dataset.n, suf=el.dataset.suf||'', D=1100;
    let t0=null;
    const f=ts=>{
      if(t0===null) t0=ts;
      const p=Math.min((ts-t0)/D,1), v=Math.round(end*(1-Math.pow(1-p,3)));
      el.textContent=v+suf;
      if(p<1) requestAnimationFrame(f);
      else el.textContent=el.dataset.n+suf;
    };
    requestAnimationFrame(f);
  }),{threshold:.4});
  els.forEach(el=>{ el.dataset.io='1'; io.observe(el); });
}
function growBars(){
  const els=$$('.bar-f[data-w]').filter(b=>!b.dataset.io);
  if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(b=>b.style.width=b.dataset.w+'%'); return; }
  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){ e.target.style.width=e.target.dataset.w+'%'; io.unobserve(e.target); }
  }),{threshold:.3});
  els.forEach(b=>{ b.dataset.io='1'; io.observe(b); });
}


let sel='solo';
const FXR=()=>{ const b=CFG.bundles[0]; const base=(window.RUNE&&RUNE.eurPrice)||197; return b.price/base; };
const eurLocal=x=>{ const v=x*FXR(); return CURISO==='EUR'?Math.round(v):Math.round(v/10)*10; };
const gv=()=>money(eurLocal(29));
function card(b){
  return '<div class="bundle'+(b.id===sel?' sel':'')+'" role="radio" tabindex="0" aria-checked="'+(b.id===sel)+'" data-bundle="'+b.id+'">'+
    (b.badge?'<span class="badge'+(b.badgeAlt?' alt':'')+'">'+esc(b.badge)+'</span>':'')+
    '<div class="b-top"><span class="radio"></span><span><span class="b-name">'+esc(b.name)+'</span><br><span class="tiny muted">'+esc(subOf(b))+'</span></span>'+
    '<span class="b-price"><b>'+money(b.price)+'</b>'+(b.save?'<span class="b-save">save '+money(b.save)+'</span>':'')+'</span></div>'+
    '<ul class="b-list">'+b.items.map(i=>'<li'+(i.base?' class="base"':'')+'>'+esc(i.t).replace('__GV__','<s class="gv">'+gv()+'</s>')+'</li>').join('')+'</ul></div>';
}
/* real stock note: only shows if inventory is tracked in Shopify and 15 or fewer are left */
function renderNotes(){
  const st=(window.RUNE&&RUNE.stock)||{};
  $$('[data-stock]').forEach(el=>{
    if(st.tracked&&st.qty>0&&st.qty<=15){ el.textContent='Only '+st.qty+' left in this batch'; el.hidden=false; } else el.hidden=true;
  });
}
function renderBundles(){
  renderNotes();
  $$('[data-bh]').forEach(h=>h.innerHTML=CFG.bundles.map(card).join(''));
  const b=CFG.bundles.find(x=>x.id===sel);
  const p=$('#pdpPrice'); if(p) p.textContent=money(b.price);
  const s=$('#pdpSave'); if(s) s.textContent=b.save?'you save '+money(b.save)+' versus buying separately':'VAT included, free shipping';
  const p2=$('#pdpPrice2'); if(p2) p2.textContent=b.name+' — '+money(b.price);
  const sp=$('#sbPrice'); if(sp) sp.textContent=money(b.price);
  const sn=$('#sbName'); if(sn) sn.textContent=b.name;
}

let cart=[], cartTotal=0;
const VMAP={};
((window.RUNE&&RUNE.variants)||[]).forEach((v,i)=>{ const id=['solo'][i]; if(id) VMAP[v]=id; });
const JH={'Content-Type':'application/json',Accept:'application/json'};
const CARTSUB={solo:'Cap, remote + The Hair Protocol guide'};
function readCart(c){
  cart=c.items.map(it=>{ const bid=VMAP[it.variant_id], b=bid&&CFG.bundles.find(x=>x.id===bid);
    const img=(bid&&window.RUNE&&RUNE.cartImgs&&RUNE.cartImgs[bid])||it.image||'';
    return {name:b?b.name:it.product_title, sub:b?CARTSUB[bid]:(it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:''), img:img, price:it.final_price/100, qty:it.quantity}; });
  cartTotal=c.total_price/100;
}
function loadCart(){ return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>{ readCart(c); renderCart(); }).catch(()=>{}); }
function add(id){
  const b=CFG.bundles.find(x=>x.id===id); if(!b||!b.vid){ location.href='/products/rune-one'; return; }
  fetch('/cart/add.js',{method:'POST',headers:JH,body:JSON.stringify({id:b.vid,quantity:1})})
    .then(r=>{ if(!r.ok) throw 0; return r.json(); }).then(()=>loadCart()).then(openCart).catch(()=>{ location.href='/cart'; });
}
function setQty(i,q){
  if(!cart[i]) return;
  fetch('/cart/change.js',{method:'POST',headers:JH,body:JSON.stringify({line:i+1,quantity:Math.max(0,q)})}).then(r=>r.json()).then(c=>{ readCart(c); renderCart(); }).catch(()=>{});
}
const total=()=>cartTotal;
function renderCart(){
  const body=$('#cartBody'), foot=$('#cartFoot');
  $('#cartCount').textContent=cart.reduce((s,i)=>s+i.qty,0);
  if(!cart.length){
    body.innerHTML='<div class="empty"><p>Your cart is empty.</p><a class="btn btn-ghost" href="/products/rune-one" data-cc>Shop the cap</a></div>';
    foot.hidden=true;
  } else {
    body.innerHTML=cart.map((i,x)=>'<div class="li"><span class="li-t">'+(i.img?'<img src="'+esc(i.img)+'" alt="">':'<i></i>')+'</span><span><span class="li-n">'+esc(i.name)+'</span><span class="li-s">'+esc(i.sub||'')+'</span><span class="qty"><button data-dec="'+x+'" aria-label="Remove one">−</button><span>'+i.qty+'</span><button data-inc="'+x+'" aria-label="Add one">+</button></span><button class="rm" data-rm="'+x+'">Remove</button></span><span class="li-r">'+money(i.price*i.qty)+'</span></div>').join('');
    foot.hidden=false; $('#cartTotal').textContent=money(total());
  }
}
function openCart(){ $('#scrim').hidden=false; requestAnimationFrame(()=>$('#scrim').classList.add('show')); $('#drawer').classList.add('show'); $('#drawer').setAttribute('aria-hidden','false'); }
function closeCart(){ $('#scrim').classList.remove('show'); $('#drawer').classList.remove('show'); $('#drawer').setAttribute('aria-hidden','true'); setTimeout(()=>{$('#scrim').hidden=true;},230); }

document.addEventListener('click',e=>{
  const t=e.target;
  const b=t.closest&&t.closest('[data-bundle]');
  if(b){ sel=b.dataset.bundle; renderBundles(); return; }
  const g=t.closest&&t.closest('[data-goto]');
  if(g){ e.preventDefault(); const el=$('#'+g.dataset.goto); if(el) el.scrollIntoView({behavior:'smooth',block:'start'}); return; }
  if(t.dataset&&t.dataset.inc!==undefined){ setQty(+t.dataset.inc,cart[+t.dataset.inc].qty+1); }
  else if(t.dataset&&t.dataset.dec!==undefined){ const i=+t.dataset.dec; setQty(i,cart[i].qty-1); }
  else if(t.dataset&&t.dataset.rm!==undefined){ setQty(+t.dataset.rm,0); }
  else if(t.closest&&t.closest('[data-cc]')) closeCart();
});
document.addEventListener('keydown',e=>{
  if(e.key==='Escape'){ closeCart(); return; }
  if(e.key!==' '&&e.key!=='Enter') return;
  const c=e.target.closest&&e.target.closest('[data-bundle]');
  if(!c) return; e.preventDefault(); sel=c.dataset.bundle; renderBundles();
});
$('#cartOpen').addEventListener('click',openCart);
$('#cartClose').addEventListener('click',closeCart);
$('#scrim').addEventListener('click',closeCart);
$('#toCheckout').addEventListener('click',closeCart);

function pageInit(){
  const r=document.body.dataset.route||'home';
  $$('[data-nav]').forEach(a=>a.classList.toggle('on',a.dataset.nav===r));
  const st=$('#sticky'); if(st) st.classList.toggle('show',r==='product');
  countUp(); growBars();
}
$('#burger').addEventListener('click',()=>{
  const n=$('#navlinks'), o=n.classList.toggle('open');
  $('#burger').setAttribute('aria-expanded',String(o));
});

/* review form */
(function(){
  const pick=$('#starPick'); if(!pick) return;
  let stars=5;
  function draw(){ pick.innerHTML=[1,2,3,4,5].map(i=>'<button type="button" data-st="'+i+'" class="'+(i<=stars?'on':'')+'" aria-label="'+i+' out of 5">★</button>').join(''); }
  pick.addEventListener('click',e=>{ const b=e.target.closest('[data-st]'); if(!b) return; stars=+b.dataset.st; draw(); });
  draw();
  $('#rvSend').addEventListener('click',()=>{
    const m=$('#rvMsg'), n=$('#rv-name').value.trim(), t=$('#rv-text').value.trim();
    if(!n||!t){ m.style.color='var(--red)'; m.textContent='Please add your name and a few words.'; return; }
    m.style.color='var(--green)';
    m.textContent='Thank you — we publish reviews once the purchase is verified.';
    $('#rv-name').value=''; $('#rv-text').value=''; stars=5; draw();
  });
})();

/* boot */
const T=f=>{ try{ f(); }catch(e){} };
T(()=>{ ['#domePdp'].forEach(s=>dome($(s))); });
T(()=>{ ring($('#domePdp')); });
T(()=>{ spectrum($('#spectrumSci')); });
T(()=>{ ['#chartPdp','#chartSci'].forEach(s=>chart($(s))); });
T(()=>{ R.bens($('#bensHome')); });
T(()=>{ R.bens($('#bensPdp')); });
T(()=>{ R.strip($('#stripHome')); });
T(()=>{ R.strip($('#stripPdp')); });
T(()=>{ R.steps($('#stepsHome')); });
T(()=>{ R.steps($('#stepsPdp')); });
T(()=>{ R.stats($('#statsHome')); });
T(()=>{ R.stats($('#statsPdp')); });
T(()=>{ R.stats($('#statsSci')); });
T(()=>{ R.mw($('#mwPdp')); });
T(()=>{ R.spec($('#specPdp')); });
T(()=>{ R.revs($('#revsHome')); });
T(()=>{ R.revs($('#revsPdp')); });
T(()=>{ R.faq($('#faqHome'),4); });
T(()=>{ R.faq($('#faqPdp'),6); });
T(()=>{ R.faq($('#faqAll')); });
T(()=>{ R.stars($('#starsPdp')); });
T(()=>{ R.stars($('#starsRev')); });
T(()=>{ R.reassure($('#reassurePdp')); });
T(()=>{ R.pays($('#paysPdp')); });
T(()=>{ R.cost($('#costHome')); });
T(()=>{ R.snip($('#snipPdp')); });
T(()=>{ $('#bundlesPdp').setAttribute('data-bh',''); });
T(()=>{ $('#bundlesBottom').setAttribute('data-bh',''); });
T(()=>{ $('#revBig').textContent=CFG.rating; });
T(()=>{ $('#revCount').textContent='Showing 3 of '+CFG.ratingCount+' reviews'; });
T(()=>{ $('#domeLedPdp').textContent=CFG.led+' diodes'; });
T(()=>{ $('#yr').textContent='2025'; });
T(()=>{ $('#pdpAdd').addEventListener('click',()=>add(sel)); });
T(()=>{ $('#pdpAdd2').addEventListener('click',()=>add(sel)); });
T(()=>{ $('#sbAdd').addEventListener('click',()=>add(sel)); });

T(()=>{ const hi=$('#heroImg'); if(hi) hi.src=(window.RUNE&&RUNE.hero)||GAL[2].src; });
(function(){
  const th=$('#thumbs'), st=$('#stage');
  if(!th||!st||!GAL.length) return;
  const old=$('#galImg'); if(old) old.remove();
  const view=document.createElement('div'); view.className='gal-view'; view.tabIndex=0; view.setAttribute('role','region'); view.setAttribute('aria-label','Product photos');
  const track=document.createElement('div'); track.className='gal-track';
  track.innerHTML=GAL.map((g,i)=>'<div class="gal-slide" style="background:'+(g.bg||'var(--paper)')+'"><img src="'+g.src+'" alt="'+esc(g.alt||'')+'" draggable="false" decoding="async"'+(i>0?' loading="lazy"':'')+'></div>').join('');
  view.appendChild(track);
  const mk=(cls,label,d)=>'<button type="button" class="gal-arrow '+cls+'" aria-label="'+label+'"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="'+d+'"/></svg></button>';
  view.insertAdjacentHTML('beforeend',mk('prev','Previous photo','M10 3L5 8l5 5')+mk('next','Next photo','M6 3l5 5-5 5')+'<span class="gal-count" aria-hidden="true"></span>');
  st.appendChild(view);
  th.innerHTML=GAL.map((g,i)=>'<button type="button" class="thumb" role="tab" data-gi="'+i+'" aria-label="Photo '+(i+1)+'"><img src="'+g.th+'" alt="" loading="lazy"></button>').join('');
  th.style.gridTemplateColumns='repeat('+Math.min(GAL.length,8)+',1fr)';
  const prev=$('.gal-arrow.prev',view), next=$('.gal-arrow.next',view), cnt=$('.gal-count',view);
  let cur=0, w=0, x0=0, y0=0, dx=0, t0=0, drag=false, lock=null;
  function update(){
    $$('.thumb',th).forEach((b,k)=>{ b.classList.toggle('on',k===cur); b.setAttribute('aria-selected',String(k===cur)); });
    prev.disabled=cur===0; next.disabled=cur===GAL.length-1; cnt.textContent=(cur+1)+' / '+GAL.length;
  }
  function set(i,animate){
    cur=Math.max(0,Math.min(GAL.length-1,i));
    track.style.transition=animate===false?'none':'';
    track.style.transform='translate3d('+(-cur*100)+'%,0,0)';
    update();
  }
  prev.addEventListener('click',()=>set(cur-1)); next.addEventListener('click',()=>set(cur+1));
  th.addEventListener('click',e=>{ const b=e.target.closest('[data-gi]'); if(b) set(+b.dataset.gi); });
  view.addEventListener('keydown',e=>{ if(e.key==='ArrowLeft'){ e.preventDefault(); set(cur-1); } else if(e.key==='ArrowRight'){ e.preventDefault(); set(cur+1); } });
  view.addEventListener('pointerdown',e=>{ if(e.target.closest&&e.target.closest('.gal-arrow')) return; x0=e.clientX; y0=e.clientY; dx=0; drag=true; lock=null; w=view.clientWidth||1; t0=Date.now(); });
  view.addEventListener('pointermove',e=>{
    if(!drag) return;
    const mx=e.clientX-x0, my=e.clientY-y0;
    if(lock===null&&(Math.abs(mx)>6||Math.abs(my)>6)){ lock=Math.abs(mx)>Math.abs(my)?'x':'y'; if(lock==='x'){ try{ view.setPointerCapture(e.pointerId); }catch(_){} track.style.transition='none'; } }
    if(lock!=='x') return;
    dx=mx; let off=dx; if((cur===0&&dx>0)||(cur===GAL.length-1&&dx<0)) off=dx*0.3;
    track.style.transform='translate3d(calc('+(-cur*100)+'% + '+off+'px),0,0)';
  });
  const end=()=>{
    if(!drag) return; drag=false;
    if(lock==='x'){ const fast=(Date.now()-t0)<280&&Math.abs(dx)>30; if(dx<-w*0.18||(fast&&dx<0)) set(cur+1); else if(dx>w*0.18||(fast&&dx>0)) set(cur-1); else set(cur); }
    lock=null;
  };
  view.addEventListener('pointerup',end); view.addEventListener('pointercancel',end);
  set(0,false);
})();
T(()=>{
  const m=$('#rvModal'), o=$('#rvOpen'), x=$('#rvClose'); if(!m||!o) return;
  const close=()=>{ m.hidden=true; document.body.style.overflow=''; o.focus(); };
  o.addEventListener('click',()=>{ m.hidden=false; document.body.style.overflow='hidden'; const f=$('#rv-name'); if(f) f.focus(); });
  x.addEventListener('click',close);
  m.addEventListener('click',e=>{ if(e.target===m) close(); });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'&&!m.hidden) close(); });
});
renderBundles(); loadCart(); pageInit();
